// extracted by mini-css-extract-plugin
export default {"placeholder":"iCIet6gRGNvcWayrpf1k"};